<template>
    <div class="third_diagram">
        <div class="one_diagram_box">
            <div class="one_diagram_box_main" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../assets/image/diagram/diagram_011.svg"
                        alt
                        srcset
                    />
                    <div
                        v-for="(item, index) in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                    >
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 21"
                            >
                                Ia(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ia }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 21"
                            >
                                Ib(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ib }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 21"
                            >
                                Ic(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ic }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="data-wrap" style="top: 3%;left: 80%">
                        <div class="data-box">
                            <div class="data-box-name">
                                Ua
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ua }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Ub
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ub }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Uc
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ uc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
export default {
    data() {
        return {
            left: "0",
            top: "-130",
            scale: 0.7,
            timer: null,
            datas: [
                {
                    point_id: "1572411373249327104",
                    name: "4011#1变进线柜（总电表1）",
                    top: 45,
                    left: 2,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572411561103814656",
                    name: "4012电房用电",
                    top: 45,
                    left: 10,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572411759003660288",
                    name: "4021G#1变电容主柜",
                    top: 45,
                    left: 14.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572411953069912064",
                    name: "4031G#1变电容辅柜",
                    top: 45,
                    left: 19,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572412049534709760",
                    name: "4042综合办公楼进线1",
                    top: 45,
                    left: 24,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572412157890359296",
                    name: "4043办公大楼",
                    top: 45,
                    left: 28.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572412260826968064",
                    name: "4041外场闸口保安值班室",
                    top: 45,
                    left: 33,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572412441370783744",
                    name: "4051海关隔离室",
                    top: 45,
                    left: 37.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572412548791103488",
                    name: "4052直流屏电源1",
                    top: 45,
                    left: 42,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572414001538625536",
                    name: "4053备用",
                    top: 45,
                    left: 46.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572414099609841664",
                    name: "4054武警楼、宿舍楼、 办公楼污水处理",
                    top: 45,
                    left: 51,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572414175279280128",
                    name: "4055外贸进出闸口、集装箱闸口",
                    top: 45,
                    left: 55.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572414258515243008",
                    name: "4056办公室应急备用电源",
                    top: 45,
                    left: 60,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572414388953903104",
                    name: "4057",
                    top: 45,
                    left: 64.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572415022293807104",
                    name: "4058宿舍楼1楼",
                    top: 45,
                    left: 69,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416008576004096",
                    name: "4061内贸进出闸口、件杂货闸口",
                    top: 45,
                    left: 73.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416106752077824",
                    name: "4062#1高杆灯",
                    top: 45,
                    left: 78,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416184271204352",
                    name: "4063#2高杆灯",
                    top: 45,
                    left: 82,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416300323401728",
                    name: "4065海关查验室、仓库2号门",
                    top: 45,
                    left: 86.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416398071656448",
                    name: "4066天浩验箱桥、天浩修箱场",
                    top: 45,
                    left: 90.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416513599565824",
                    name: "4064  986自动查验箱、9B场地磅",
                    top: 45,
                    left: 94.7,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572425284438683648",
                    name: "5000发电机进线",
                    top: 92,
                    left: 0,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                // {
                //     point_id: "1572417074029883392",
                //     name: "4131#2变进线市电",
                //     top: 92,
                //     left: 1.5,
                //     ia: "",
                //     ib: "",
                //     ic: ""
                // },
                {
                    point_id: "1572417193588518912",
                    name: "4121G#2变电容主柜",
                    top: 92,
                    left: 6,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572417340825366528",
                    name: "4111G#2变电容辅柜",
                    top: 92,
                    left: 10.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572417425407700992",
                    name: "4102宿舍楼2--8层照明",
                    top: 92,
                    left: 15,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572417496509542400",
                    name: "4101发电机电机充电开关",
                    top: 92,
                    left: 19.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572419871261552640",
                    name: "4103发电机房配电箱AF",
                    top: 92,
                    left: 24,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572420083287814144",
                    name: "4105内贸闸口保安值班室",
                    top: 92,
                    left: 28.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572420652828160000",
                    name: "4104自来水泵电源",
                    top: 92,
                    left: 34,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572423434079531008",
                    name: "4091理货仓库，仓库1#门",
                    top: 92,
                    left: 38.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572423612572332032",
                    name: "4092佛山正盈租用9#--12#门",
                    top: 92,
                    left: 43,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572423792906432512",
                    name: "4093办公楼停车场路灯",
                    top: 92,
                    left: 48.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572423862997446656",
                    name: "4094#3高杆灯",
                    top: 92,
                    left: 54,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424098499227648",
                    name: "4095#4高杆灯",
                    top: 92,
                    left: 59.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424180887941120",
                    name: "4096外堆场",
                    top: 92,
                    left: 64,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424289419751424",
                    name: "4097佛山正盈租用3#--8#门",
                    top: 92,
                    left: 69.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424429501116416",
                    name: "4083办公楼消防及重要负荷电源",
                    top: 92,
                    left: 75,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424523591938048",
                    name: "4081泵房消防配电柜（备供）1#",
                    top: 92,
                    left: 80.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424593154469888",
                    name: "4084海关楼2--4楼",
                    top: 92,
                    left: 85,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572424704731344896",
                    name: "4082泵房消防配电柜（备供）2#",
                    top: 92,
                    left: 90,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572416720575885312",
                    name: "4000联络",
                    top: 92,
                    left: 95,
                    ia: "",
                    ib: "",
                    ic: ""
                }
            ],
            ua: "",
            ub: "",
            uc: ""
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 1000 * 60);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    if (item.point_id == "1572411373249327104") {
                        this.ua = point && point.v_a;
                        this.ub = point && point.v_b;
                        this.uc = point && point.v_c;
                    }
                    item.ia = point && point.a_a;
                    item.ib = point && point.a_b;
                    item.ic = point && point.a_c;
                });
            });
        },
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function(event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function(event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function(en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function(en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function() {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.third_diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    .one_diagram_box {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .one_diagram_box_main {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;
            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }

                .data-wrap {
                    position: absolute;
                    color: #fff;
                    font-size: 0.7rem;
                    .data-box {
                        display: flex;
                        height: 1.4rem;
                        line-height: 1.4rem;
                        margin-bottom: 0.2rem;
                        .data-box-name {
                            color: #dbf743;
                            //   width: 1.4rem;
                        }
                        .data-box-data {
                            width: 3.8rem;
                            text-align: right;
                            background: #111f45;
                            border-radius: 0.8rem;
                            display: inline-flex;
                            .box-data-data {
                                flex: 1;
                                text-align: center;
                            }
                            .box-data-unit {
                                width: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
